<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="650">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline">Unggah Surat Tugas</v-card-title>

        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="2" sm="2" md="3" lg="3" xl="3">
              <v-img src="https://cdn.siap.id/s3/simpkb/asset img/guru-praktik-baik/modal-informasi.png"></v-img>
            </v-col>
            <v-col cols="10" sm="10" md="9" lg="9" xl="9">
              <div class="text-left mb-0 pb-0">
                <p>Kepada Bapak/Ibu <strong>Peserta Diklat GTK seri Bahasa Inggris</strong></p>
                <p>
                  Untuk Bapak/Ibu Peserta seri <b>Pengembangan Kompetensi Guru Bahasa Inggris (PKGBI)</b> yang mengikuti <b>LMS Pembelajaran</b>. Mohon untuk dapat mengunggah
                  <strong>Surat Tugas pada dokumen unggahan</strong>.
                </p>
                <p class="pb-1 mb-0">Format Surat Tugas dapat dilihat pada link dibawah ini</p>
                <p class="pt-0"><a href="https://docs.google.com/document/d/10wQSv-23j19qGeg6YGtdIjOvzYZobu0-/edit" target="_blank">Format Dokumen Surat Tugas</a></p>
                <p>Terima Kasih</p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black--text" text @click="closeGuide">Tutup</v-btn>
          <v-btn color="primary" @click="toUnggahBerkas" :loading="loading">Unggah Dokumen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature
export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false
    };
  },

  methods: {
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open() {
      this.dialog = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    //@vuese
    //tutup dialog
    closeGuide() {
      this.dialog = false;
      this.resolve();
    },
    //@vuese
    //buka link join telegram sesuai konfigurasi
    toUnggahBerkas() {
      this.$router.push({ name: "user.berkas" });
      this.dialog = false;
      this.resolve();
    }
  }
};
</script>
